import React from 'react';

const ExpandIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="13" viewBox="0 0 20 13">
    <path fill="#A6A6A6" fillRule="evenodd" d="M17.283 12.333L10 5.05l-7.283 7.283L.5 10.117l9.5-9.5 9.5 9.5z" />
  </svg>
);

export default ExpandIcon;
